import { render, staticRenderFns } from "./MLHGNumber.vue?vue&type=template&id=4f7f290d"
import script from "./MLHGNumber.vue?vue&type=script&lang=js"
export * from "./MLHGNumber.vue?vue&type=script&lang=js"
import style0 from "./MLHGNumber.vue?vue&type=style&index=0&id=4f7f290d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports